<template>
	<div
		:id="'modal-' + id"
		class="c-checklist-media-block__modal"
		:class="{ 'is-open': isopen === id }"
		:key="index"
		:ref="'modal-' + id"
	>
		<div class="c-checklist-media-block__modal-content">
			<div class="c-checklist-media-block__modal-body">
				<p class="c-checklist-media-block__modal-text text-h5">
					{{ text }}
				</p>
			</div>
			<div class="c-checklist-media-block__modal-content-pointer"></div>
		</div>
	</div>
</template>

<script>
import VuexStore from "../../js/vuex-store/vuex-store.js";
import { mapState } from "vuex";

export default {
	name: "VChecklistPopupModal",
	store: VuexStore,
	props: {
		id: {
			type: String
		},
		index: {
			type: Number
		},
		text: {
			type: String
		}
	},
	computed: {
		...mapState({
			isopen: state => state.checklist.showModal
		})
	},
	methods: {
		openModal() {
			this.$store.commit("checklist/setShowModal", this.id);
		}
	}
};
</script>
